import {
    handle as publicHandle,
    loader,
    default as ProfessionalArticlesRoute,
} from '~/routes/_app.professional.$urlSegment.journal.$';
import { prefetchProfessionalJournalImages } from '~/routes/_app.professional.$urlSegment.journal.$';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { mergeMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const isDesktop = data?.deviceType === 'desktop';
        const preloadImages = data?.searchResult?.hits
            ? prefetchProfessionalJournalImages(
                  data?.searchResult.hits,
                  isDesktop,
              )
            : [];
        return [...preloadImages];
    },
);

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    ...publicHandle,
    disabledInPreview,
};

export { loader };
export default ProfessionalArticlesRoute;
